// Copyright (c) 2015-present, salesforce.com, inc. All rights reserved

import * as types from './actionTypes';

// eslint-disable-next-line import/prefer-default-export
export function setLanguageInStore (payload) {
	return {
		type: types.SET_LANGUAGE,
		payload
	};
}

export function markLangChanged (payload) {
	return {
		type: types.LANGUAGE_CHANGED,
		payload
	};
}
